import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/ReadyPlayerMe-Avatar.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Some quick facts <span className="purple"> AboutMe </span>
            </h1>
            <p className="home-about-body">
              ・I enjoy Cooking and Outdoor Fishing videos
              <br />
              <br /> ・I'm a foodie
              <i>
                <b className="purple"> 🍖 </b>
              </i>
              <br />
              <br />
              ・I enjoy learning new things and meeting new people &nbsp;
              <i>
                {/* <b className="purple">・Easy going persoanilty </b> and
                also in areas related to{" "}
                <b className="purple">
                  learning AI.
                </b> */}
              </i>
              <br />
              <br />
              ・I love
              <i>
                <b className="purple">
                  {" "}
                  Strawberry
                </b>
              </i>
              &nbsp; Cheescake 😁🍰
              {/* <i>
                <b className="purple"> React.js, and Angular</b>
              </i> */}

            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Add, Follow, Connect 😄</h1>
            <p>
              Feel free to add me on my <span className="purple">Socials 💻 </span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://gitlab.com/Camezy"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/CamezyTv"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/cameron-ross-62909b189/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
